import { createClient } from "@supabase/supabase-js";

const supabaseUrl = process.env.REACT_APP_SUPABASE_CHATORANOTE_URL;
const supabaseAnonKey = process.env.REACT_APP_SUPABASE_CHATORANOTE_ANON_KEY;

export const supabase = createClient(supabaseUrl, supabaseAnonKey);
